<template>
  <v-container>
      <div class="countprodotto_upper"> <p class="count_proddoto_upper"> {{ prodottoText }} ({{ countprodotto }})  </p> </div>
  </v-container>
</template>

<script>
import checkLanguage from "../../../classes/class_check_language";
export default {
  name: "count_prodotto",
  data() {
    return {
      product_id: "",
      // countprodotto: 0,
      prodottoText: "PRODOTTO",
    };
  },
  
  mounted() {
    // controllo se inglese 
    let i = new checkLanguage();
    if (!i.is_italian()){
      this.prodottoText = "PRODUCT";
    }
    try {
      let e = document.getElementById("dfnweio3");
      this.product_id = e.getAttribute("post");
    } catch (error) {
      this.product_id = 744;
    }

    // this.countprodotto = this.$store.state.quantita;
  },
  computed: {
     countprodotto() {
      return this.$store.state.products.SORGENTE.length;
    },
  },
};
</script>

<style scoped>
.countprodotto_upper {
  padding-left: 55px;
  font-size: 15px !important;
  color: #20221e;
  padding-top: 0px;
  z-index: 100;
  position: relative;
}

.count_proddoto_upper {
  font-size: 12px !important;
   color:#ADACAC;
}

.count_proddoto_upper p {
  font-size: 12px !important;
  color:#ADACAC;
}


</style>